export enum ConfigKeys {
  AUTHENTICATION_PATH_URL = 'AUTHENTICATION_PATH_URL',
  DEV_TOOLS_ENABLED = 'DEV_TOOLS_ENABLED',
  DEV_UI_FLAGS = 'DEV_UI_FLAGS',
  ENVIRONMENT = 'ENVIRONMENT',
  PUBLIC_API_URL = 'PUBLIC_API_URL',
}

export enum EUIFlags {
  CPE_ORDERS_UI_FEATURE_ENABLED = 'CPE_ORDERS_UI_FEATURE_ENABLED',
  PAUSE_PLAN_FEATURE_ENABLED = 'PAUSE_PLAN_FEATURE_ENABLED',
  REFERRALS_ENABLED = 'REFERRALS_ENABLED',
}

export enum ELocalStorageKeys {
  DEV_TOOLS_OPEN = 'DEV_TOOLS_OPEN',
  MOCK_SERVICE_ENABLED = 'MOCK_SERVICE_ENABLED',
  UI_DEV_FLAGS = 'UI_DEV_FLAGS',
  VENDOR_API_VERSION = 'VENDOR_API_VERSION',
}

export enum ECookieKeys {
  'XSRF-TOKEN' = 'XSRF-TOKEN',
}
